import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import styles from './faq.module.scss';
import handleCTAClick from '../../services/helpers/handleCTAClick';
import AccordionWrapper from '../accordion/accordionWrapper';
import CtaButton from '../ctaButton/ctaButton';

export default function Faq({
  title = '',
  items = [],
  cta = null,
  expanded = false,
}) {
  const data = items?.map((item, index) => {
    const key = `faq-${index}`;
    return (
      <AccordionWrapper
        key={key}
        id={key}
        head={parse(
          `<h3 data-testid='${item?.question}'>${item?.question}</h3>`
        )}
        /* eslint-disable-next-line react/no-children-prop */
        body={parse(
          `<div><div data-testid='${item.answer}'>${item.answer}</div></div>`
        )}
        expanded={expanded}
        borderBottom={index === items.length - 1}
      />
    );
  });

  return (
    <div className={styles.faq}>
      <div className={styles.questions}>
        {title && <h2 className={styles.title}>{title}</h2>}
        <div className={styles.accordion}>{data}</div>
      </div>
      {cta && (
        <div className={styles.cta}>
          <CtaButton
            label={cta.label}
            aria-label={cta.label}
            variant={cta?.variant}
            color={cta?.color}
            type="button"
            fullWidth
            onClick={(e) => handleCTAClick(e, cta)}
            href={cta.link}
          />
        </div>
      )}
    </div>
  );
}

Faq.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string,
    })
  ),
  cta: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  expanded: PropTypes.bool,
};
